import { Map } from 'immutable';

import { GET_ALL_AGENT_DETAILS, ADD_BALANCE, CHANGE_STATUS, UPDATE_OPERATOR,EDIT_DLT, ADD_SENDER_ID,CHANGE_DEFAULT_SENDER_ID,ADD_SMS_TYPE, ADD_BLOCK_NUMBER,GET_BLOCK_NUMBER,CHANGE_PASSWORD, DELETE_SENDER_ID, GET_TENANT_DETAILS, GET_TENANT_USERS, IMPERSONATE_USER, GET_TENANT_SMS_CONFIG, SET_DEFAULT_SMS_TYPE, ADMIN_LIST_TEMPLATES, ADMIN_CREATE_TEMPLATE, ADMIN_UPDATE_TEMPLATE, ADMIN_DELETE_TEMPLATE, ADMIN_LIST_API_KEYS_BY_TENANT, ADMIN_PROVISION_MACHINE_USER_API_KEY } from '../lib/constant';

const initialState = Map({agentResponse : {},addBalanceResponse:{},changeStatusResponse:{}, updateOperatorResponse: {},editDLTResponse: {}, addSenderIdResponse:{}, changeDefaultSenderIdResponse:{}, addSMSTypeResponse:{}, addBlockNoResponse:{}, blockNumberResponse:{}, changePasswordResponse:{}, deleteSenderIdResponse: {}, tenantDetailsResponse: {}, tenantUsersResponse: {}, impersonateUserResponse: {} });

export default function(state = initialState , action ) {
	switch(action.type){
        case GET_ALL_AGENT_DETAILS :
            return {...state,agentResponse:action.payload};
		case ADD_BALANCE :
			return {...state,addBalanceResponse:action.payload};
		case CHANGE_STATUS :
			return {...state,changeStatusResponse:action.payload};
		case UPDATE_OPERATOR :
			return {...state,updateOperatorResponse:action.payload};
		case EDIT_DLT :
			return {...state,editDLTResponse:action.payload};
		case ADD_SENDER_ID :
			return {...state,addSenderIdResponse:action.payload};
		case CHANGE_DEFAULT_SENDER_ID :
			return {...state,changeDefaultSenderIdResponse:action.payload};
		case ADD_SMS_TYPE :
			return {...state,addSMSTypeResponse:action.payload};
		case ADD_BLOCK_NUMBER:
			return {...state,addBlockNoResponse:action.payload};
		case GET_BLOCK_NUMBER:
			return {...state,blockNumberResponse:action.payload};
		case CHANGE_PASSWORD:
			return {...state,changePasswordResponse:action.payload};
		case DELETE_SENDER_ID:
			return { ...state, deleteSenderIdResponse: action.payload };
		case GET_TENANT_DETAILS:
			return { ...state, tenantDetailsResponse: action.payload };
		case GET_TENANT_USERS:
			return { ...state, tenantUsersResponse: action.payload };
		case IMPERSONATE_USER:
			return { ...state, impersonateUserResponse: action.payload };
		case GET_TENANT_SMS_CONFIG:
			return { ...state, tenantSmsConfigResponse: action.payload };
		case SET_DEFAULT_SMS_TYPE:
			return { ...state, setDefaultSmsTypeResponse: action.payload };
		case ADMIN_LIST_TEMPLATES:
			return { ...state, adminTemplatesResponse: action.payload };
		case ADMIN_CREATE_TEMPLATE:
			return { ...state, adminCreateTemplateResponse: action.payload };
		case ADMIN_UPDATE_TEMPLATE:
			return { ...state, adminUpdateTemplateResponse: action.payload };
		case ADMIN_DELETE_TEMPLATE:
			return { ...state, adminDeleteTemplateResponse: action.payload };
		case ADMIN_LIST_API_KEYS_BY_TENANT:
			return { ...state, adminApiKeysResponse: action.payload };
		case ADMIN_PROVISION_MACHINE_USER_API_KEY:
			return { ...state, adminProvisionApiKeyResponse: action.payload };
        default :
		     return state;
    }
}
